'use client';

import { useEffect, useLayoutEffect, useMemo, useState } from 'react';
import tailwindConfig from '@/utils/tailwind';

const breakPoints = tailwindConfig.theme.screens;
const isSSR: boolean = typeof window === 'undefined';

export type TWindowSizesType = [number, number];
export type TBreakPointKeysType = keyof typeof breakPoints;

const useIsomorphicLayoutEffect = isSSR ? useEffect : useLayoutEffect;
const getWindowSize = (): TWindowSizesType => {
  return !isSSR ? [window.innerWidth, window.innerHeight] : [0, 0];
};

export const useWindowSizes = (): TWindowSizesType => {
  const [size, setSize] = useState<TWindowSizesType>(getWindowSize);

  useIsomorphicLayoutEffect(() => {
    const updateSize = () => setSize(getWindowSize());
    window.addEventListener('resize', updateSize);
    return () => window.removeEventListener('resize', updateSize);
  }, []);

  return size;
};

export const useBreakPointsDown = (
  breakPointKeys: TBreakPointKeysType[]
): boolean[] => {
  const [width] = useWindowSizes();

  return useMemo(() => {
    return breakPointKeys.map(
      (breakPointKey) => parseInt(breakPoints[breakPointKey]) > width
    );
  }, [breakPointKeys, width]);
};

export const useBreakPointDown = (
  breakPointKey: TBreakPointKeysType
): boolean => {
  return useBreakPointsDown([breakPointKey])[0];
};

export const useBreakPointsUp = (
  breakPointKeys: TBreakPointKeysType[]
): boolean[] => {
  const [width] = useWindowSizes();

  return useMemo(() => {
    // const widths: number[] = Object.values(breakPoints)
    //   .map((width) => parseInt(width as string))
    //   .sort((a, b) => a - b);

    return breakPointKeys.map((breakPointKey) => {
      const currentBreakPointWidth: number = parseInt(
        breakPoints[breakPointKey]
      );

      // const currentBreakPointWidthIndex: number = widths.findIndex(
      //   (width: number) => currentBreakPointWidth === width
      // );
      // const nextBreakPointWidth: number =
      //   widths?.[currentBreakPointWidthIndex + 1] || currentBreakPointWidth;
      //
      // return width >= nextBreakPointWidth;
      return width >= currentBreakPointWidth;
    });
  }, [breakPointKeys, width]);
};

export const useBreakPointUp = (
  breakPointKey: TBreakPointKeysType
): boolean => {
  return useBreakPointsUp([breakPointKey])[0];
};
